import * as React from 'react';
import AppFooter from '../modules/views/AppFooter';
import CtaBand from '../modules/views/CtaBand';
import NavBar from '../modules/views/NavBar';
import withRoot from '../modules/withRoot';
import CaseCards from '../modules/views/CaseCards';
import { CARDS_CASE } from '../Const';
import PageMeta from '../modules/components/PageMeta';

function Index() {
  return (
    <React.Fragment>
      <PageMeta
        title="施工事例"
        description="飯田建築の施工事例。新築・リフォーム・オフィス・店舗の実績を写真でご紹介します。埼玉県入間市を中心に、飯能・狭山・所沢・青梅エリアで施工しています。"
        path="/case"
      />
      <NavBar />
      <CaseCards
        title={'施工事例'}
        eyebrow="Works"
        lead="新築・リフォーム・オフィスの施工事例をご紹介します。"
        cards={CARDS_CASE}
        animation={'animate__animated animate__fadeIn'}
        enableMessage={true}
      />
      <CtaBand />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
